import { render, staticRenderFns } from "./purchase-dialog-claim-withdraw.vue?vue&type=template&id=4c28a731&"
import script from "./purchase-dialog-claim-withdraw.vue?vue&type=script&lang=js&"
export * from "./purchase-dialog-claim-withdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports